<template>
  <div>
    <Form :model="setting" :label-width="200" inline>
      <FormItem :label="$t('pages_settings_restaurant_1013')">
        <i-switch
          v-model="setting.open_order_auto_expired"
          size="large"
          @on-change="change('open_order_auto_expired')"
        >
          <span slot="open">{{$t('pages_customer_level_index_294')}}</span>
          <span slot="close">{{$t('pages_birthday_discount_index_209')}}</span>
        </i-switch>
      </FormItem>
      <br/>
      <FormItem :label="$t('pages_settings_restaurant_1014')">
        <i-switch
          v-model="setting.open_member_count"
          size="large"
          @on-change="change('open_member_count')"
        >
          <span slot="open">{{$t('pages_customer_level_index_294')}}</span>
          <span slot="close">{{$t('pages_birthday_discount_index_209')}}</span>
        </i-switch>
      </FormItem>
      <br/>
<FormItem :label="$t('pages_settings_restaurant_1015')" v-if="setting.open_order_auto_expired">
<Input style="width: 500px" type="number" :placeholder="$t('pages_settings_restaurant_1016')" v-model="setting.order_auto_expired_minutes" @on-blur="change('order_auto_expired_minutes')" />
      </FormItem>
    </Form>
  </div>
</template>

<script>
import i18n from '../../locales/index'

import { mapGetters, mapActions } from 'vuex'

export default {
  data () {
    return {
      switch1: false
    }
  },
  created () {
    this.display()
  },
  computed: {
    ...mapGetters('setting', ['setting'])
  },
  methods: {
    ...mapActions('setting', ['display', 'upgrade']),
    change (key) {
      this.upgrade({ [key]: this.setting[key] })
    },
  }
}
</script>
